import { render, staticRenderFns } from "./A_little_off_the_wall_humor.vue?vue&type=template&id=7c7b7c5f&"
import script from "./A_little_off_the_wall_humor.vue?vue&type=script&lang=js&"
export * from "./A_little_off_the_wall_humor.vue?vue&type=script&lang=js&"
import style0 from "./A_little_off_the_wall_humor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports